import { ReactNode } from "react";
import { create } from "zustand";
import { Organization } from "../organizations/types";

export type ModalPayload = {
  title?: string;
  message: string | ReactNode;
  organizations?: Organization[],
  confirmText?: string;
  onConfirm?: () => void;
  canCancel?: boolean;
};

type ModalState = {
  modal: ModalPayload | null;
  showModal: (payload: ModalPayload) => void;
  closeModal: () => void;
};

export const useModalStore = create<ModalState>((set) => ({
  modal: null,

  showModal: (payload) =>
    set({
      modal: {
        title: payload.title ?? "Error",
        confirmText: payload.confirmText ?? "OK",
        ...payload,
      },
    }),

  closeModal: () => set({ modal: null }),
}));
